import { render, staticRenderFns } from "./sidebar-terminplanung.vue?vue&type=template&id=06570542&scoped=true"
import script from "./sidebar-terminplanung.vue?vue&type=script&lang=js"
export * from "./sidebar-terminplanung.vue?vue&type=script&lang=js"
import style0 from "./sidebar-terminplanung.vue?vue&type=style&index=0&id=06570542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06570542",
  null
  
)

export default component.exports